import { ResourceOptions } from 'react-admin';
import { FaCog } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.socialTradingRedpacketConfig;
export const icon = FaCog;
export const options: ResourceOptions = {
  label: 'module.socialTrading.redpacketConfig',
};
